<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <button class="btn btn-outline-secondary mb-3" @click="selectAllFields">
        Նշել ամբողջը
      </button>
      <span v-tooltip="'Հեռացնել ամբողջը'" @click="deleteElements" class="pointer">
        <i class="remove far fa-trash-alt"></i>
      </span>
    </div>
    <div :key="key" class="w-100 border rounded mb-3"
         style="height: 55vh; overflow-y: auto">
      <div v-for="(lot, index) in lots"
           :key="index"
           class="todo-box nav-link todo-box-link">
        <div class="d-flex justify-content-between py-2 align-items-center">
          <span class="name-cpv">{{ +index + 1 }} | {{ lot.code }}{{ lot.drop && '/' }}{{ lot.drop }} - {{ lot.name }}</span>
          <div class="d-flex align-items-center">
            <span v-tooltip="'Հեռացնել'" @click.stop="$emit('deleteLot', {lotId: lot.id, nextLotIndex: index + 1})" class="text-danger">
              <i class="remove far fa-trash-alt"></i>
            </span>
            <input type="checkbox" class="ml-2" @click.stop="(event) => handleSelectItem(event, lot)" :checked="selectItem" name="selectedLot">
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <button type="button"
              @click="$modal.show('add-cpv-modal', handleAddRows)"
              class="btn btn-sm btn-outline-primary btn-round dual-btn-icon" data-toggle="modal"
              data-animation="bounce" data-target=".bd-example-modal-xl">Գնման Առարկա
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LotList',
    props: ['lots', 'addLots', 'deleteLots'],
    data() {
      return this.getModalInitialState()
    },
    mounted() {},
    methods: {
      deleteElements(){
        this.$modal.show('delete-modal', {
          msg: 'Հեռացնե՞լ ընտրված գնման առարկաները',
          callback: async () => {
            this.$emit('deleteLots', this.selectedItems)
            this.$modal.hide('delete-modal')
            this.selectedItems = [];
            this.selectItem = false;
            this.key = this.key + 1;
          }
        })
      },
      selectAllFields(){
        this.selectedItems = []
        this.selectItem = !this.selectItem
        if(this.selectItem){
          Object.assign(this.selectedItems, this.lots)
        } else {
          this.selectedItems = []
        }
      },
      getModalInitialState(){
        return {
          selectItem: false,
          selectedItems: [],
          key: 0
        }
      },
      handleSelectItem(event, selectedItem){
        if(event.target.checked){
          this.selectedItems.push(selectedItem)
        } else {
          const selectedItemIndex = this.selectedItems.indexOf(selectedItem)
          this.selectedItems.splice(selectedItemIndex, 1)
        }
      },
      consoleLog(e){
        console.log(e)
      },
      changeType(value){
        if(this.lots.length){
          this.$fire({
            showCancelButton: true,
            title: "Զգուշացում",
            text: "Սույն գործողությունը կջնջի արդեն իսկ մուքագրած չափաբաժինները",
            type: "warning",
            confirmButtonText: 'Շարունակել',
            cancelButtonText: 'Ետ',
          }).then(async(result) => {
            if (result.value) {
              this.fromOutside = value;
              await this.lots.forEach(async(lot) => {
                await this.$client.delete(`organize-row/${lot.id}`)
              })
              await this.$store.dispatch('organize/getRows', {organizeId: this.$route.params.id})
              await this.$store.dispatch('organizeOnePerson/getRows', {organizeId: this.$route.params.id})
            } else {
              this.fromOutside = !value;
            }
          })
        }
      },
      handleAddRows(rows){
        this.$emit('addLots', rows)
      }
    },
  }
</script>
<style scoped>
  .pointer{
    cursor: pointer;
  }
</style>